import { Component } from '@angular/core';
import {
  WithSubscriptionComponent,
  EnterpriseSearchService
} from '@sabstravtech/obtservices/angular';

@Component({
  template: '',
  standalone: false
})
export class BaseSearchComponent extends WithSubscriptionComponent {
  constructor(protected searchService: EnterpriseSearchService) {
    super();
  }

  public performSearch() {
    if (this.searchService.validateForms()) {
      this.searchService.startSearches();
    }
  }
}
